// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__xBP2W","description":"PatientConsentPreview_description__28csH"};